export default "__VITE_ASSET__BlMtUKMp__"